<script>


import SidebarLink from "./SidebarLink.vue"

import {collapsed, toggleSidebar, sidebarWidth} from "./state"

export default {
    props: {},
    components: {SidebarLink},
    setup() {
        return {collapsed, toggleSidebar, sidebarWidth}
    },
}
</script>

<template>
    <div class="sidebar" :style="{width: sidebarWidth}">
        <h1 id="logo">
            <span id = "collapsed-icon" v-if="collapsed">
                <!-- <div>O</div> -->
                <fa icon="meteor" style="color: #528382"/>
                 
            </span>
            <span v-else>
                <fa icon="meteor" style="color: #528382" size="3x" />
                <!-- <p>Ohrli</p> -->
                <p style="color: #528382">MeteOhr</p>
                <!-- <fa icon="blog"/>
                <fa icon="deaf"/>
                <fa icon="lightbulb"/> -->
            </span>
        </h1>
        
        <div> <!-- Überkapitel -->
        <SidebarLink to="/" icon="1.">Intro & Ziele</SidebarLink> 
        <SidebarLink to="/AufbauOhr" icon="2.">Aufbau & Funktion</SidebarLink>
        </div>

        <div class="Unterkapitel"> <!-- Unterkapitel -->
        <SidebarLink to="/Außenohr" icon="2.1">Außenohr</SidebarLink>
        <SidebarLink to="/Mittelohr" icon="2.2">Mittelohr</SidebarLink>
        <SidebarLink to="/Innenohr" icon="2.3">Innenohr</SidebarLink>
        <!-- <SidebarLink to="/AufbauPraxis" icon="2.4">Praxis</SidebarLink> -->
        <SidebarLink to="/AufbauQuiz" icon="2.4">Abfrage</SidebarLink>
        </div>

        <div>
        <SidebarLink to="/Audio" icon="3.">Audio & Signale</SidebarLink>
        </div>

        <div class="Unterkapitel"> <!-- Unterkapitel -->
        <SidebarLink to="/PhysikalischeGrundlagen" icon="3.1">Grundlagen</SidebarLink>
        <SidebarLink to="/Signale" icon="3.2">Signale</SidebarLink>

            <SidebarLink to="/Audiosignale" icon="3.3">Audiosignale</SidebarLink>
            <SidebarLink to="/Audiokurs" icon="3.4">Audio</SidebarLink>

        <!-- <SidebarLink to="/AudioPraxis" icon="3.3">Praxis</SidebarLink> -->
        <SidebarLink to="/AudioQuiz" icon="3.5">Abfrage</SidebarLink>
        
        </div>

        
        
        
        <span
        class="collapse-icon"
        :class="{'rotate-180' : collapsed}"
        @click="toggleSidebar"
        
        >
        <!-- <i class="arrow-bar-right" /> -->
        <fa icon="arrow-alt-circle-left" size="2x" />
        <!-- <b-icon-arrow-bar-right></b-icon-arrow-bar-right> -->
        
        </span>
    </div>
</template>

<style>

:root {
    --sidebar-bg-color: #ffffff;
    --sidebar-item-hover: #669b992a;
    --sidebar-item-active: #52838286;

    /*--sidebar-bg-color: #6c9f9e;
    --sidebar-item-hover: #669b99;
    --sidebar-item-active: #528382;*/
}
</style>

<style scoped>
#collapsed-icon {
    margin-left: -23px;
    color: #292b2c;
}
h1 {
    height: 230px;
}
.sidebar {
    color: rgb(255, 255, 255);
    background-color: var(--sidebar-bg-color);

    float: left;
    position: fixed;
    z-index: 1;
    top: 57px;
    left: 0;
    bottom: 0;
    padding: 0.5em;

    transition: 0.3s ease;

    display: flex;
    flex-direction: column;
}
.Unterkapitel {
    padding-left: 1em;
}
.collapse-icon {
    position: absolute;
    bottom: 0;
    padding: 0.75em;

    /*color: rgba(255, 255, 255, 0.7);*/
    color: #528382;

    transition: 0.2s linear;
}

.rotate-180{
    transform: rotate(180deg);
    transition: 0.2s linear;
}
</style>